import { useMediaQuery } from '@mui/material';

export default function useTab() {
    return useMediaQuery('(min-width: 768px) and (max-width: 1243px)');
}